import styled, { keyframes } from 'styled-components';
import * as palette from '../../styles/variables';

export const fadeText = keyframes` 
   from {
     opacity: 0;
     transform: translate3d(0, 100%, 0);
   }
   to {
     opacity: 1;
     transform: none;
   }
 `;

export const GetStarted = styled.div`
  margin: 10px auto;
  button:hover {
    cursor: pointer;
  }
  button {
    pointer-events: ${props => props.disabled && 'none'} !important;
    opacity: ${props => props.disabled && '0.5'}!important;
    font-size: ${props => (props.large ? '16px' : props.medium ? '14px' : '12px')}!important;
    font-family: ${palette.FONT_FAMILY_LANDPAGE} !important;
    background-color: ${palette.APP_BRAND_YELLOW_COLOR};
    border: ${palette.APP_BRAND_YELLOW_COLOR};
    color:${palette.BLACK_COLOR};
    position: relative;
    overflow: hidden;   
    font-weight: 700 !important;
    letter-spacing: 1px;   
    line-height: 1.3;   
    padding:10px 30px;
    text-transform: uppercase;
    border-radius: 64px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 10px;   
  }
  button:hover:before {
    opacity: 1;
    transform: translate(0, 0);
  }
  button:before {
    content: attr(data-hover);
    position: absolute;
    left: 0;
    width: 100%;
    text-transform: uppercase;
    opacity: 0;
    transform: translate(0, 100%);
    transition: all 0.2s ease-in-out;
  }
  button:hover div {
    opacity: 0;
    transform: translate(0, -100%);
  }
  button div {
    text-transform: uppercase;
    transition: all 0.2s ease-in-out;
  }
  .loading {
    font-size: 18px;
  }
`;
